import { OnChanges } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { IPreCurrency } from 'src/app/apis/preload-system.service';
import { AppCore } from 'src/app/utils/classes/app-core';
import { currencys } from 'src/app/utils/constants/currencys';

@Component({
  selector: 'app-show-currency',
  templateUrl: './show-currency.component.html',
  styleUrls: ['./show-currency.component.scss']
})
export class ShowCurrencyComponent implements OnChanges {
  @Input() Currency: string;
  @Input() WithImg: string = '30px';
  CurrencyActive: IPreCurrency;
  constructor() { }
  ngOnChanges(): void {
    this.onSetInit();
  }

  onSetInit() {
    var find = currencys.find(c => c.currency == this.Currency);
    if (find) {
      this.CurrencyActive = find;
    } else {
      this.CurrencyActive = {
        currency: "THB",
        description: "Thai Baht",
        img_flag: "https://cdn.ggautopay.com/images/flags/3d/th.png"
      };
    }
  }
}
